import React, {useEffect, useState} from 'react';
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addMonths} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {selectServiceRequest} from "../../../api/serviceRequest/ServiceRequestService";
import {PageHeader} from "../../../components/PageHeader";
import {CustomTable, CustomTh, SubContainer} from "../../lifecycle/rentalAsset/rentalAssetViewCss";
import {BtnSearchBtn} from "../../../components/buttons/style/ButtonStyle";
import {getFeedbackOverview} from "../../../api/static/StaticRequestService";
import {getDateAsString} from "../../../components/Utils/Utils";
import TableMovable from "../../../components/table/movable/TableMovable";
import {SERVICE_REQUEST_HEADER} from "../../../components/table/header/Headers";
import CommonPagination from "../../../components/table/movable/CommonPagination";
import {OverviewType} from "../../../constant/CodeSpecNum";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import {cn} from "../../../shadCn/lib/utils";
import Printer from "../../../resources/icon/pirnter-bw.png";

const ServiceRequestFeedbackOverview = () => {
    const initialData = {
        startDate: toKSTISOString(addMonths(new Date(), -2)),      // 2달전
        endDate: toKSTISOStringEnd(addMonths(new Date(), 0)),
        codeIds : []
    }
    const [search, setSearch] = useState(initialData);
    const [serviceRequestStatics, setServiceRequestsStatics] = useState([]);
    const [primeServiceCodes, setPrimeServiceCodes] = useState([]);
    const [checked, setChecked] = useState(true);

    const { data, pageInfo,dataHook} =
        useRequestData((conditions, pageable) => {
            const additionalCondition = {
                //만족도 조사 완료된 처리기준 90
                progressNumericValue: 90
            };
            const finalConditions = {
                ...conditions,
                ...additionalCondition
            };
            return selectServiceRequest(finalConditions, pageable);
        }, initialData, "feedBackOverView");

    useEffect(() => {
        handleCallData();
    }, []);

    const handleCallData = async () => {
        await getFeedbackOverview(search, (data) => {
            const staticsData = data;
            setServiceRequestsStatics([...staticsData]);
            const codes = staticsData.map(code => ({id: code.primeId, name: code.name}));
            setPrimeServiceCodes([...codes]);
            const primeCodeIds = codes.map(code => code.id);
            setSearch((prev) => ({...prev, codeIds: [...primeCodeIds]}));
        });
    }

    const handlePrimeCodeCheck = (id) => {
        /** check한 코드 id가 codeIds 에 포함되있다면 제거, 포함되지 않았다면 추가한다. */
        if (search.codeIds.includes(id)) {
            const list = search.codeIds;
            const filtered = list.filter(codeId => id !== codeId);
            setSearch(prev => ({...prev, codeIds: [...filtered]}));
        } else {
            const list = search.codeIds;
            list.push(id)
            setSearch(prev => ({...prev, codeIds: [...list]}));
        }
    }

    const handleOverviewSearch = async () => {
        await getFeedbackOverview(search, (data) => {
            setServiceRequestsStatics([...data]);
        })
        dataHook.handleSearch(search);
    }

    const getFeedbackOverviewResult = (avgValue) => {
        if (avgValue === 0) return "";
        if (avgValue <= 5 && avgValue >= 4) {
            return OverviewType.EXCELLENT.kor;
        } else if (avgValue < 4 && avgValue >= 3) {
            return OverviewType.OUTSTANDING.kor;
        } else if (avgValue < 3 && avgValue >= 2) {
            return OverviewType.AVERAGE.kor;
        } else if (avgValue < 2 && avgValue >= 1) {
            return OverviewType.INSUFFICIENT.kor;
        } else if (avgValue < 1 && avgValue > 0) {
            return OverviewType.POOR.kor;
        }
    }

    const handleAllCheck = () => {
        if (checked) {
            setSearch(prev => ({...prev, codeIds: []}));
        } else {
            const list = primeServiceCodes.map(e => e.id);
            setSearch(prev => ({...prev, codeIds: [...list]}));
        }

        setChecked(!checked);
    }

    return (
        <div className={"common-container container-height-full"}>
            <PageHeader header={"요청만족도현황"} indicator={"서비스요청 > 요청만족도현황"}/>
            <SubContainer>
                <div>
                    <div>서비스요청 그룹</div>
                    <SubContainer className={'mt-2 flex flex-wrap'}>
                        <div className={'flex gap-2 mr-4 mb-1 max-w-[8rem] cursor-pointer'}>
                            <input
                                id={`check-all`}
                                type={`checkbox`}
                                checked={checked}
                                onChange={() => handleAllCheck()}
                                className={`ml-[5px]`}
                            />
                            <label htmlFor={`check-all`} className={'w-[6rem] truncate'}>전체선택</label>
                        </div>

                        {primeServiceCodes.length > 0 && primeServiceCodes.map((item, index) =>
                            <div key={`index-${index}`} className={'flex gap-2 mr-4 mb-1 max-w-[8rem] cursor-pointer'}>
                                <input
                                    id={`check-${index}`}
                                    type={`checkbox`}
                                    checked={search.codeIds.includes(item.id)}
                                    onChange={() => handlePrimeCodeCheck(item.id)}
                                    className={`ml-[5px]`}
                                />
                                <label htmlFor={`check-${index}`} className={'w-[6rem] truncate'}>{item.name}</label>
                            </div>
                        )}
                    </SubContainer>
                    <div className={'mt-4 flex gap-2'}>
                        <span className="mr-2 text-[12px] line-height-30">등록일시</span>
                        <div className={"flex"}>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setSearch, "startDate", v, false)}
                                data={search.startDate}
                                constraint={{lessThan: search.endDate && dayjs(search.endDate)}}
                                auth/>
                            <span className={cn("ml-2 mr-2 text-[20px]")}> ~ </span>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setSearch, "endDate", v, false)}
                                data={search.endDate}
                                constraint={{largerThan: search.startDate && dayjs(search.startDate)}}
                                auth/>
                        </div>
                        <BtnSearchBtn display={'inline-block'} background={'#eeeded'} onClick={handleOverviewSearch}>상세검색</BtnSearchBtn>
                    </div>
                </div>
            </SubContainer>

            <div className={'my-5 flex justify-between'}>
                <div>1. 조회기간 내역</div>
                <div className={'mr-2 print-none'}>
                    <abbr title={"인쇄하기"}>
                        <button className="mr-3" onClick={() => window.print()}>
                            <img src={Printer} className={`w-[30px] h-[30px] mt-[5px] border`}/>
                        </button>
                    </abbr>
                </div>
            </div>

            <SubContainer>
                <p className={`text-[1.5rem] text-center`}>서비스요청만족도</p>
                <div className={"mt-8"}>
                    대상기간 : {getDateAsString(false, search.startDate)} ~ {getDateAsString(false, search.endDate)}
                </div>
                <div className={"mt-8"}>
                <span className={"mt-8"}>종합평가</span>
                    <CustomTable>
                        <tbody>
                        <tr>
                            <CustomTh background={'#f1f6f9'}>종합평가점수</CustomTh>
                            <CustomTh background={'#f1f6f9'}>5점</CustomTh>
                            <CustomTh background={'#f1f6f9'}>4점 이상</CustomTh>
                            <CustomTh background={'#f1f6f9'}>3점 이상</CustomTh>
                            <CustomTh background={'#f1f6f9'}>2점 이상</CustomTh>
                            <CustomTh background={'#f1f6f9'}>1점 이하</CustomTh>
                        </tr>
                        <tr>
                            <CustomTh background={'#ffffff'} align={'center'}>평가등급</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>A(탁월)</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>B(우수)</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>C(보통)</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>D(미흡)</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>E(불량)</CustomTh>
                        </tr>
                        </tbody>
                    </CustomTable>
                </div>
                <div className={'mt-8'}>
                    <span>종합평가</span>
                    <CustomTable>
                        <tbody>
                        <tr>
                            <CustomTh background={'#f1f6f9'} rowSpan={2}>구분</CustomTh>
                            <CustomTh background={'#f1f6f9'} rowSpan={2}>측정지표</CustomTh>
                            <CustomTh background={'#f1f6f9'} colSpan={2}>만족도 실적</CustomTh>
                        </tr>
                        <tr>
                            <CustomTh background={'#ffffff'}>측정결과</CustomTh>
                            <CustomTh background={'#ffffff'}>평가점수</CustomTh>
                        </tr>
                        </tbody>
                        <tbody>
                        {serviceRequestStatics.length > 0 && serviceRequestStatics.map((service, index) =>
                            <React.Fragment key={`service-${index}`}>
                                <tr>
                                    <CustomTh rowSpan={3}>{service.name}</CustomTh>
                                    <CustomTh>만족도평균</CustomTh>
                                    <CustomTh>{service.feedbackAvg}</CustomTh>
                                    <CustomTh rowSpan={3}>{getFeedbackOverviewResult(service.feedbackAvg)}</CustomTh>
                                </tr>
                                <tr>
                                    <CustomTh>만족도평가건수</CustomTh>
                                    <CustomTh>{service.feedbackCount}</CustomTh>
                                </tr>
                                <tr>
                                    <CustomTh>총 요청건수</CustomTh>
                                    <CustomTh>{service.total}</CustomTh>
                                </tr>
                            </React.Fragment>
                        )}
                        </tbody>
                    </CustomTable>
                </div>
            </SubContainer>

            <div className={'my-5 print-none'}>
                <div>2. 조회기간 상세내역</div>
            </div>
            <SubContainer className={'print-none'}>
                <div className={'min-h-[23rem]'}>
                    <TableMovable data={data} header={SERVICE_REQUEST_HEADER} page={pageInfo} url={'/serviceRequest/serviceRequest'} size={10}/>
                </div>
                <CommonPagination page={pageInfo} onPageChange={dataHook.handlePageChange}/>
            </SubContainer>
        </div>
    );
};

export default ServiceRequestFeedbackOverview;